(function () {
  if (document.documentElement.dataset.lcCardCheckoutInitialized === 'true') return;
  document.documentElement.dataset.lcCardCheckoutInitialized = 'true';

  /**
   * @returns {Promise<boolean>}
   */
  async function prepareCardCheckout() {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            _payment_pref: '',
          },
        }),
      });

      if (!response.ok) return false;

      const cart = await response.json();
      const pref = cart.attributes && cart.attributes._payment_pref;

      return pref !== 'havale';
    } catch {
      return false;
    }
  }

  /**
   * @param {Event} event
   */
  async function handleCardCheckoutClick(event) {
    const target = event.target;
    const button =
      target instanceof Element ? target.closest('[data-lc-card-checkout]') : null;

    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    button.disabled = true;

    const ready = await prepareCardCheckout();

    if (!ready) {
      button.disabled = false;
      return;
    }

    const pushBeginCheckout = window.__pushDatalayerBeginCheckout;
    if (typeof pushBeginCheckout === 'function') {
      await pushBeginCheckout();
    }

    window.location.assign('/checkout');
  }

  document.addEventListener('click', handleCardCheckoutClick, true);

  const havaleButtonBackground = '#82b85c';

  function syncHavaleButtonBackground() {
    document.querySelectorAll('[data-havale-button], .havale-button').forEach((node) => {
      if (!(node instanceof HTMLElement)) return;

      node.style.setProperty('background-color', havaleButtonBackground, 'important');
      node.style.setProperty('background', havaleButtonBackground, 'important');
    });
  }

  function observeHavaleButtons() {
    syncHavaleButtonBackground();

    const targets = [
      document.querySelector('#cart-drawer'),
      document.querySelector('.cart-form'),
      document.querySelector('.cart-page'),
    ].filter((target) => target instanceof HTMLElement);

    if (!targets.length) return;

    const observer = new MutationObserver(syncHavaleButtonBackground);

    targets.forEach((target) => {
      observer.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeHavaleButtons);
  } else {
    observeHavaleButtons();
  }
})();
